import { connect } from 'react-redux';

import actions from './actions';


const defaultMapStateToProps = (state) => {
  return { rs: state };
}

const defaultMapDispatchToProps = (dispatch) => {
  return {
    rd: actions(dispatch),
  }
}

const dconnect = connect(defaultMapStateToProps, defaultMapDispatchToProps);

export default {
  connect: dconnect
};
